module.exports = __webpack_public_path__ + "img/mem_one.f44edd19.png";